import { render, staticRenderFns } from "./TemplateEditorActions.vue?vue&type=template&id=9f4d5bbc&scoped=true"
import script from "./TemplateEditorActions.vue?vue&type=script&lang=ts"
export * from "./TemplateEditorActions.vue?vue&type=script&lang=ts"
import style0 from "./TemplateEditorActions.vue?vue&type=style&index=0&id=9f4d5bbc&prod&scoped=true&lang=css"
import style1 from "./TemplateEditorActions.vue?vue&type=style&index=1&id=9f4d5bbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4d5bbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VMenu,VRow})
